import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_DinhMucCoDinhVatTuTable = _resolveComponent("DinhMucCoDinhVatTuTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!

  return (_ctx.dinhMucCoDinhDetail)
    ? (_openBlock(), _createBlock(_component_PageContentSection, { key: 0 }, {
        header: _withCtx(() => [
          _createTextVNode("Trong định mức")
        ]),
        actions: _withCtx(() => [
          (_ctx.showCreatePhieuXuatButton)
            ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                key: 0,
                "button-type": _ctx.ButtonsType.ADD,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                "is-disabled": _ctx.isButtonDisabled,
                "tooltip-message": _ctx.buttonTooltipMessage,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: 'tao-moi-phieu-xuat-kho',
            query: {
              idBienBan: String(_ctx.idBienBan),
              loaiDinhMuc: 'trong-dinh-muc',
              ...(_ctx.idKho ? { idKho: String(_ctx.idKho) } : {}),
            },
          })
        ))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Phiếu xuất")
                ]),
                _: 1
              }, 8, ["button-type", "color-type", "is-disabled", "tooltip-message"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DinhMucCoDinhVatTuTable, {
            "cur-page": _ctx.currentPage,
            items: _ctx.vatTuItems,
            "is-loading": false,
            "per-page": _ctx.perPage
          }, null, 8, ["cur-page", "items", "per-page"]),
          (!!_ctx.dinhMucCoDinhDetail && _ctx.vatTuItems.length > 0)
            ? (_openBlock(), _createBlock(_component_Pagination, {
                key: 0,
                page: _ctx.currentPage,
                total: _ctx.totalItems,
                onChangePage: _cache[1] || (_cache[1] = (value) => (_ctx.currentPage = value)),
                onChangePageSize: _cache[2] || (_cache[2] = (value) => (_ctx.perPage = value))
              }, null, 8, ["page", "total"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}